import { notification } from "antd";
import axiosMakeInstance from "../axiosMakeInstance";
import { EnterpriseRequest } from "../../../types/enterprise";

const createEnterprise = async (payload: EnterpriseRequest): Promise<void> => {
  try {
    const response = await axiosMakeInstance.post(
      import.meta.env.VITE_ENTERPRISE_CREATION_URL ||
        "/xdgivdeq63pc61fsaah254hhu7yt3okk",
      payload
    );

    notification.success({
      message: "Sucesso",
      description: "Seus arquivos já estão sendo gerados.",
    });
    return response.data;
  } catch (error) {
    console.error("Error in Make:", error);
    throw new Error(`${error}`);
  }
};

export const enterpriseService = {
  createEnterprise,
};
